export default __webpack_public_path__ + "static/media/loginbg.6d8cd10a.png";